module.exports = __webpack_public_path__ + "img/sm-arrows-expand.8dc54d84.svg";